import styled from 'styled-components';
import { Card, Heading1, theme } from '@ovotech/element-v5';
import { Card as NebulaCard } from '@ovotech/nebula'; // Temporarily using Nebula Card in some places to match other pages

export const HeadingCard = styled(NebulaCard)`
  /* Padding to match cards on Meter readings, Billing history, Payments pages */
  padding: ${theme.space[1100]} ${theme.space[700]};
`;

export const TopupHeading = styled(Heading1)`
  color: ${theme.color.surface.onSurface};
`;

export const BalanceBox = styled(Card)`
  background-color: ${theme.color.surface.surface};
  padding: ${theme.space[400]};
`;

export const BalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
